import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Bloomington, MN?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office in Bloomington can take 2–6 months, especially during busy travel seasons. For MSP Airport business travelers and families with cruise departures, that timeline is simply not viable.",
  },
  {
    q: "Can I get a passport fast if I live near the Mall of America?",
    a: "Absolutely. Your proximity to MSP Airport makes expedited service even more important. Many Mall of America area residents travel internationally for business and leisure. We regularly process expedited renewals and new applications for Bloomington families with compressed timelines — as fast as 2–9 business days.",
  },
  {
    q: "What if my passport expires before a flight from MSP?",
    a: "This is one of the most common urgent situations we see from Bloomington. Many countries require six months validity beyond your return date. If your expiration is cutting it close, we strongly recommend expedited processing. Standard mail-in renewal through a Bloomington post office typically takes 2–6 months — far too long for an upcoming flight.",
  },
  {
    q: "Can Normandale students get a passport fast for study abroad?",
    a: "Yes. Study-abroad program deadlines often fall in October and February, but many students do not think about their passport until after acceptance. First-time applicants require an in-person acceptance clerk visit. We guide Normandale Community College students through the exact location, forms, and timeline so they do not miss their program orientation. Expedited processing is available for students with confirmed travel.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Bloomington travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Bloomington, but that is the point: you do not need one. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the Twin Cities metro area.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
  {
    q: "Can Edina and Richfield residents use the same expedited service?",
    a: "Yes. Edina, Richfield, and Minneapolis travelers have the same access to our expedited services as Bloomington residents. Since we operate remotely, your physical location in Hennepin County does not affect processing speed. Ship your documents overnight from any UPS or FedEx location, and we handle the rest.",
  },
];

export default function BloomingtonFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Bloomington and south metro travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}